import { UserHttpService } from 'src/app/http/user-http.service';
import { BranchHttpService } from './../http/branch-http.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserNewHttpResolverService implements Resolve<any> {
    constructor(private branchHttpService: BranchHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.branchHttpService.getAllBranches();
    }
}

@Injectable({
    providedIn: 'root',
})
export class UserEditHttpResolverService implements Resolve<any> {
    constructor(private userHttpService: UserHttpService, private branchHttpService: BranchHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getUserById = this.userHttpService.getUserById(route.params.id);
        let getAllBranches = this.branchHttpService.getAllBranches();
        return forkJoin([getUserById, getAllBranches]);
    }
}

@Injectable({
    providedIn: 'root',
})
export class UserListHttpResolverService implements Resolve<any> {
    constructor(private userHttpService: UserHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.userHttpService.getAllUsers();
    }
}

@Injectable({
    providedIn: 'root',
})
export class UserPasswordEditHttpResolverService implements Resolve<any> {
    constructor(private userHttpService: UserHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.userHttpService.getUserById(route.params.id);
    }
}
